import { Button, Input, Modal, Radio, Row, Spin } from 'antd';
import React, { Component } from 'react';
import { orderStatus, permissions } from './../../../../constants';
import lang from './../../../../languages/en';
import { alertWarning, showConfirm } from './../../../../services/dialog';
import { fieldRequiredItems, fieldRomaji } from './../../../../services/fieldRequired';
import { iconEmpty } from './../../../../services/helper';
import history from './../../../../services/history';
import { regexIsRomanji } from './../../../../services/ruleValidate';
import Storage from './../../../../services/Storage';
import handlePermission from './../../../app/handlePermission';
import { ListChannel as ListChannelCost } from "./../../../../constants/setting_channel";
import './styles.css';
import { isArray } from 'util';
import { checkContainProhibitedItem } from "./../../../../services/prohibitedHelper";

const RadioGroup = Radio.Group;
const Search = Input.Search;
const confirm = Modal.confirm;

class ModalComponent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            listCountries: Storage.get('countries') ? Storage.get('countries') : [],
            searchCountry: Storage.get('countries') ? Storage.get('countries') : [],
            disabledSearchItem: true,
            setPermisson: !handlePermission(permissions.OrderUpdateOrder) ? true : false
        }
    }

    renderSearchItemCode = () => {
        if (!this.props.listItemName.filterItemCode.length) {
            return iconEmpty()
        }
        return this.props.listItemName.filterItemCode.map((value, key) => {
            return (
                <Radio
                    key={key}
                    value={value.SKU}
                    className='checked-search-item'
                >{value.ItemName_US}</Radio>
            )
        })
    }

    renderSearchOrigin = () => {
        if (!this.state.searchCountry.length) {
            return iconEmpty()
        }
        return this.state.searchCountry.map((value, key) => {
            return (
                <Radio
                    key={key}
                    value={value.CountryCode}
                    className='checked-search-item'
                >{`${value.CountryCode} - ${value.Description}`}</Radio>
            )
        })
    }

    fillItem = (e) => {
        let listItemName = this.props.listItemName.listItemName
        let items = [...this.props.itemOrder]
        let selected_item_code = this.props.order.selected_item_code
        let row_item = this.props.order.row_item
        let itemName = {}
        let countries = Storage.get('countries')
        let countriesNew = []
        let itemContainSkuCurrent = false
        let errorOrder = this.props.order.error
        let information = this.props.order.information;
        let { information : { channel_short_name } } = this.props.order;
        let { prohibitedItems } = this.props;

        for (let j = 0; j < countries.length; j++) {
            countriesNew.push(countries[j]['CountryCode'])
        }

        for (let i = 0; i < listItemName.length; i++) {
            if (listItemName[i].SKU === selected_item_code) {
                itemName = listItemName[i]
            }
        }

        for (let k = 0; k < items.length; k++) {
            if (items[k].sku === selected_item_code) {
                itemContainSkuCurrent = {
                    value: true,
                    key: items[k].key
                }
            }
        }

        let itemCodeFill = itemName.ItemCode
            && typeof itemName.ItemCode === 'string' ? itemName.ItemCode.trim() : itemName.ItemCode
        let itemNameFill = itemName.ItemName_US
            && typeof itemName.ItemName_US === 'string' ? itemName.ItemName_US.trim() : itemName.ItemName_US
        let itemOriginFill = itemName.CountryOfOriginCH
            && typeof itemName.CountryOfOriginCH === 'string' ? itemName.CountryOfOriginCH.trim() : itemName.CountryOfOriginCH
        // let itemValueFill = itemName.UnitPriceFL
        //     && typeof itemName.UnitPriceFL === 'string' ? itemName.UnitPriceFL.trim() : itemName.UnitPriceFL
        let itemValueFill = itemName.OriginalPriceFL
            && typeof itemName.OriginalPriceFL === 'string' ? itemName.OriginalPriceFL.trim() : itemName.OriginalPriceFL
        let itemSkuFill = itemName.SKU
            && typeof itemName.SKU === 'string' ? itemName.SKU.trim() : itemName.SKU
        let itemHasApproveKeyWordBLFill = itemName.HasApproveKeyWordBL;
        let itemProhibitedKeyWordFill = itemName.ProhibitedKeyWord;
        items.map((item, key) => {
            if (item.key === row_item) {
                item.item_code = itemCodeFill
                item.item_name = itemNameFill
                item.origin = itemOriginFill
                item.price_adjusted = itemValueFill
                item.HasApproveKeyWordBL = itemHasApproveKeyWordBLFill
                item.ProhibitedKeyWord = itemProhibitedKeyWordFill
                let index = errorOrder.indexOf('origin' + item.key)

                if (itemContainSkuCurrent.value && row_item !== itemContainSkuCurrent.key) {
                    item.sku = null
                    alertWarning(lang.item_code_existed, lang.item_code_existed_line2)
                } else {
                    item.sku = itemSkuFill
                }

                if (!itemOriginFill || (countriesNew.indexOf(itemOriginFill) !== -1)) {
                    if (index !== -1) {
                        errorOrder.splice(index, 1)
                    }
                    item.classes.origin = ''
                } else {
                    if (index === -1) {
                        errorOrder.push('origin' + item.key)
                    }
                    item.classes.origin = 'error'
                }

                for (let m = 0; m < fieldRomaji.length; m++) {
                    if (item[fieldRomaji[m]]) {
                        if (!regexIsRomanji(item[fieldRomaji[m]])) {
                            item.classes[fieldRomaji[m]] = 'error'
                        } else {
                            item.classes[fieldRomaji[m]] = ''
                        }

                        if (fieldRomaji[m] === 'item_name') {
                            let indexField = errorOrder.indexOf(fieldRomaji[m] + item.key)

                            if (!regexIsRomanji(item[fieldRomaji[m]])) {
                                item.classes[fieldRomaji[m]] = 'error'
                                if (indexField === -1) {
                                    errorOrder.push(fieldRomaji[m] + item.key)
                                }
                            } else {
                                item.classes[fieldRomaji[m]] = ''
                                if (indexField !== -1) {
                                    errorOrder.splice(indexField, 1)
                                }
                            }
                        }
                    }
                }

                for (let k = 0; k < fieldRequiredItems.length; k++) {
                    if (!item[fieldRequiredItems[k]]
                        || (fieldRequiredItems[k] === 'channel_order_item'
                            && !regexIsRomanji(item[fieldRequiredItems[k]]))) {
                                item.classes[fieldRequiredItems[k]] = 'error';

                                //case fieldRequiredItems is channel_order_item set error folow channel
                                if (fieldRequiredItems[k] === 'channel_order_item') {
                                    if (channel_short_name === ListChannelCost.AMAZON_JP.ShortName) {
                                        item.classes[fieldRequiredItems[k]] = 'error'
                                    } else {
                                        item.classes[fieldRequiredItems[k]] = ''
                                    }
                                }
                                
                        
                    } else {
                        item.classes[fieldRequiredItems[k]] = ''
                    }
                }

                if (!item.classes['item_name']) {
                    let ProhibitedKeyWord = checkContainProhibitedItem(item.item_name, prohibitedItems);
                    if (isArray(ProhibitedKeyWord) && ProhibitedKeyWord.length > 0) {
                        item.classes['item_name'] = 'warring';
                        item.HasApproveKeyWordBLOrigin = null;
                        item.ProhibitedKeyWord = ProhibitedKeyWord;
                    }
                }
            }

            return item;
        })
        this.props.onChangeItem(items)
        this.props.onChange({ value: errorOrder, column: 'error' })
        this.props.onChange({ value: '', column: 'selected_item_code' })
        this.props.onChange({ value: false, column: 'search_item_code' })
        this.props.onChange({ value: '', column: 'tooltip' })
        this.props.pageType === 'editOrder' && this.props.onChange({value: false, column: 'buttonEditOrderDisabled'})
    }

    fillOrigin = (e) => {
        let items = [...this.props.itemOrder]
        let selected_origin = this.props.order.selected_origin
        let row_item = this.props.order.row_item

        items.map((item, key) => {
            if (item.key === row_item) {
                item.origin = selected_origin

                if (selected_origin) {
                    let errorOrder = this.props.order.error
                    let index = errorOrder.indexOf('origin' + item.key)

                    item.classes.origin = ''
                    if (index !== -1) {
                        errorOrder.splice(index, 1)
                    }
                }
            }

            return item;
        })
        this.props.onChangeItem(items)
        this.props.onChange({ value: '', column: 'selected_origin' })
        this.props.onChange({ value: false, column: 'search_origin' })
        this.props.pageType === 'editOrder' && this.props.onChange({value: false, column: 'buttonEditOrderDisabled'})
    }

    onSearchCountry = (value) => {
        let searchCountry = this.state.listCountries.filter((item, key) => {
            return item.CountryCode.search(value.toUpperCase()) !== -1
        })

        this.setState({
            searchCountry
        })
    }

    onSearchItemCode = (value) => {
        let listItemName = [...this.props.listItemName.listItemName]

        let filterItemCode = listItemName.filter((item, key) => {
            return ((item.ItemCode.toLowerCase().indexOf(value.toLowerCase()) !== -1) || (item.SKU.toLowerCase().indexOf(value.toLowerCase()) !== -1))
        })

        this.props.filterItemCode(filterItemCode)
    }

    confirmDeleteOrder = () => {
        let _this = this;
        const { order } = this.props

        if (orderStatus['SENT_TO_SHIPMENT'] === order.information.status_id || orderStatus['CANCEL'] === order.information.status_id) {
            Modal.warning({
                title: lang.shipment_exist,
                content: lang.shipment_exist_content,
                autoFocusButton: null
            });
            return;
        } else {
            return (
                confirm({
                    title: lang.comfirm_delete_order,
                    content: lang.warning_delete_order,
                    autoFocusButton: null,
                    onOk() {
                        _this.deleteOrderFromEditOrder()
                    }
                })
            )
        }
    }

    restoreOrder = () => {
        this.props.onChange({ value: true, column: 'isLoading' })
        this.props.restoreOrder({ channel_order: this.props.order.information.channel_order, channel_id: 2 })
    }

    deleteOrderFromEditOrder = () => {
        this.props.onChange({ value: true, column: 'isLoading' })
        this.props.deleteOrderFromEditOrder([this.props.information.ID])
    }

    onCancelItemCode = () => {
        this.props.onChange({ value: '', column: 'selected_item_code' })
        this.props.onChange({ value: false, column: 'search_item_code' })
    }

    onCancelOrigin = () => {
        this.props.onChange({ value: false, column: 'search_origin' })
        this.props.onChange({ value: '', column: 'selected_origin' })
    }

    confirmSaveOrder = () => {
        const { order } = this.props

        if (order.dumplicateValueItem) {
            this.props.onChange({ value: 0, column: 'dumplicateValueItem' })
            return
        }

        this.props.confirmSaveOrder()
    }

    render() {
        const { pageType, order, order: { information } } = this.props
        this.props.confirm_save_order ?
            showConfirm(lang.comfirm_save_when_error,
                this.props.onSaveOrders,
                () => this.props.onChange({ value: false, column: 'confirm_save_order' }),
                lang.comfirm_save_when_error_step2
            ) : null

        return (
            <div id="modal-component" className='modal-add-order'>
                <Row className="footer-component">
                    <div className="fix-footer">
                        <div className='navbar-cancel-save-add-order'>
                            {(pageType == 'editOrder'
                                && !this.state.setPermisson
                                && handlePermission(permissions.OrderDelete)
                                && information.status_id !== orderStatus.SPLIT) ? (
                                <Button
                                    className="delete"
                                    onClick={() => this.confirmDeleteOrder()}
                                    disabled={orderStatus['SENT_TO_SHIPMENT'] === order.information.status_id}
                                >Delete Order</Button>
                            ) : null}
                            {this.state.setPermisson || information.status_id === orderStatus.SPLIT && (
                                <Button
                                    className="save"
                                    type="primary"
                                    onClick={() => {
                                        history.push('/orders')
                                        this.props.keepState(true)
                                    }}
                                >Close</Button>
                            )}
                            {!this.state.setPermisson && information.status_id !== orderStatus.SPLIT && (
                                <Button className="cancel" onClick={() => {
                                    if (pageType === 'addOrderInShipment') {
                                        history.goBack()
                                        this.props.keepState(true)
                                    } else {
                                        history.push('/orders')
                                        this.props.keepState(true)
                                    }
                                }}
                                >Cancel</Button>
                            )}
                            {!this.state.setPermisson && information.status_id !== orderStatus.SPLIT && (
                                <Button
                                    className="save"
                                    type="primary"
                                    onClick={() => this.confirmSaveOrder()}
                                    disabled={(orderStatus['SENT_TO_SHIPMENT'] === order.information.status_id)
                                        || (pageType === 'editOrder' && order.buttonEditOrderDisabled)}
                                >Save</Button>
                            )}
                        </div>
                    </div>
                </Row>
                <Modal
                    title="Search item"
                    visible={this.props.order.search_item_code}
                    onOk={(e) => this.fillItem(e)}
                    okText='ADD'
                    maskClosable={false}
                    onCancel={() => this.onCancelItemCode()}
                    className={(this.props.order.selected_item_code ? 'search_popup_not_disable_button' : '') + ' search_item_popup'}
                    okButtonProps={{ disabled: this.props.order.selected_item_code ? false : true }}
                >
                    <Spin spinning={this.props.itemName.isLoading} tip="Loading...">
                        <div>
                            <div className='search-box-item-cde'>
                                <Search
                                    placeholder="Please input SKU or CHANNEL ITEM CODE"
                                    onChange={e => this.onSearchItemCode(e.target.value)}
                                    id='input-search-sku-channel-item-code'
                                />
                            </div>
                            <div className='content-item-code'>
                                <h3 className='title-field'>ITEM NAME (EN)</h3>
                                <RadioGroup
                                    onChange={(e) => this.props.onChange({ value: e.target.value, column: 'selected_item_code' })}
                                    style={{ width: '100%' }}
                                    className='list-search-item-code'
                                    value={this.props.order.selected_item_code}
                                >
                                    {this.renderSearchItemCode()}
                                </RadioGroup>
                            </div>
                        </div>
                    </Spin>
                </Modal>
                <Modal title="Search origin"
                    visible={this.props.order.search_origin}
                    onOk={(e) => this.fillOrigin(e)}
                    onCancel={() => this.onCancelOrigin()}
                    maskClosable={false}
                    className={(this.props.order.selected_origin ? 'search_popup_not_disable_button' : '') + ' search_item_popup'}
                    okText='ADD'
                    okButtonProps={{ disabled: this.props.order.selected_origin ? false : true }}
                >
                    <div>
                        <div className='search-box-item-cde'>
                            <Search
                                placeholder="Please input Origin"
                                onChange={e => this.onSearchCountry(e.target.value)}
                            />
                        </div>
                        <div className='content-item-code'>
                            <h3 className='title-field'>Origin Name</h3>
                            <RadioGroup
                                onChange={(e) => this.props.onChange({ value: e.target.value, column: 'selected_origin' })}
                                value={this.props.order.selected_origin}
                            >
                                {this.renderSearchOrigin()}
                            </RadioGroup>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default ModalComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/modal-component/index.js